import { render, staticRenderFns } from "./lookCompleteData.vue?vue&type=template&id=3fbae9fd&scoped=true"
import script from "./lookCompleteData.vue?vue&type=script&lang=js"
export * from "./lookCompleteData.vue?vue&type=script&lang=js"
import style0 from "./lookCompleteData.vue?vue&type=style&index=0&id=3fbae9fd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbae9fd",
  null
  
)

export default component.exports